import { cevir } from "@/lib/dil";
import { tarih } from "@/lib/veri";

/**
 * D-074 Faz 2 (K28): "Mark as historical entry…" / "Remove historical entry mark…" onay metni (window.confirm; satırlar \n ile).
 * `acilis`: işin OASIS'te açıldığı an (`tamir_kalemi.olusturma_ts`); kişiye gösterilir, karar vermez.
 */
export function gecmisIsOnayi(isaret: boolean, acilis: string): string {
  if (isaret) {
    return [
      cevir("Mark this job as a historical entry?"),
      cevir("Use this only for work done before it was entered into OASIS. This job was opened in OASIS on {0}.", tarih(acilis)),
      cevir("Its OASIS stamps (step closures, fit-up release, pass entries) will no longer count as work dates; the date checks that will use only document dates are not active yet. Nothing else on the job changes. The marking is kept in the audit log."),
    ].join("\n");
  }
  return [
    cevir("Remove the historical entry mark from this job?"),
    cevir("Its OASIS stamps will count as work dates again where a document gives no date. Nothing else on the job changes. The change is kept in the audit log."),
  ].join("\n");
}
